import { ff } from './ffSelectors';
import { filterAvailableRoutes } from './filterAvailableRoutes';
import { integrationSelectors } from './integrationSelectors';
import { userSelectors } from './userSelectors';
function impersonatingAs(state) {
    return state.claims ? state.claims.impersonate : null;
}
export const selectors = {
    ff,
    user: userSelectors,
    integration: integrationSelectors,
    filterAvailableRoutes,
    impersonatingAs,
    intercomUserJwt (state) {
        var _ref;
        var _state_userInfo;
        return (_ref = (_state_userInfo = state.userInfo) === null || _state_userInfo === void 0 ? void 0 : _state_userInfo.intercomUserJwt()) !== null && _ref !== void 0 ? _ref : null;
    },
    intercomUserJwtReceivedAt (state) {
        return state.intercomUserJwtReceivedAt;
    },
    isBootNetworkFailure (param) {
        let { authError } = param;
        return (authError === null || authError === void 0 ? void 0 : authError.kind) === 'networkError';
    },
    isResetPasswordFlow (param) {
        let { claims } = param;
        return claims ? claims.setPasswordOnly : false;
    },
    isSetIdentityFlow (param) {
        let { claims } = param;
        return claims ? claims.setIdentityOnly : false;
    },
    mgmtHost (state) {
        return state.session.mgmtHost;
    },
    hasSentAProposal (state) {
        var _state_businessInfo;
        return ((_state_businessInfo = state.businessInfo) === null || _state_businessInfo === void 0 ? void 0 : _state_businessInfo.hasSentAProposal) || false;
    },
    hasSentASampleProposal (state) {
        var _state_businessInfo;
        return ((_state_businessInfo = state.businessInfo) === null || _state_businessInfo === void 0 ? void 0 : _state_businessInfo.hasSentASampleProposal) || false;
    },
    showMissingColumnBankAccountBannerExceptKyb (s) {
        const userInfo = s.userInfo;
        return !!userInfo && userInfo.isVendor() && (userInfo.isOwner() || userInfo.isAdmin()) && !userInfo.paymentsDisabled() && userInfo.columnEntityCreated() && userInfo.hasColumnAccountId() && userInfo.hasColumnWalletAccountId() && !userInfo.hasColumnPayoutAccountId();
    },
    shouldLoadAppcues (s) {
        return userSelectors.isVendor(s) && s.session.enableAppcues;
    },
    isRealUser (s) {
        return !!(s.userInfo && s.userInfo.id() && !impersonatingAs(s));
    },
    locationStack (s) {
        return s.locationStack;
    },
    showBusinessSwitcher (s) {
        return !!s.userInfo && !userSelectors.isAccountant(s) && !userSelectors.isAnchorAdmin(s);
    },
    isViewMode (s) {
        var _s_claims;
        return ((_s_claims = s.claims) === null || _s_claims === void 0 ? void 0 : _s_claims.viewAsClientEmail) != null;
    }
};
